// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"745":"6f5a19276064deb3","940":"b22b4761c310ddf3"}[chunkId] + ".js";
};